<template>
  <Loading v-if="componentLoading" :style="style" />
  <Chart v-else-if="visible" class="compare-line-chart" :option="chartConfig" :style="style"></Chart>
</template>

<script lang="ts" setup>
import Chart from "@p-v/packages/Charts/BaseChart/index.vue"
import Loading from "@p-v/packages/Loading.vue"
import { ref } from "vue"
import { cloneDeep, defaultsDeep } from "lodash-es"
import config from "./config"
import useToggle from "@p-v/hooks/useToggle"
import type { DataItem, HorizonBarChartProps } from "./index.d"
import { EChartsOption } from "echarts"

const componentLoading = ref<boolean>(true)

const props = withDefaults(defineProps<HorizonBarChartProps>(), {
  config: () => ({}),
  style: () => ({}),
  show: () => true,
})
const { visible, show, hide, changeVisible } = useToggle(props.show)

const chartConfig = ref(cloneDeep(config))

/**
 * 数据处理
 * @param config
 * @param dataList
 */
function componentPropEngine(propsData: HorizonBarChartProps): EChartsOption {
  const { data, config: _config } = propsData
  const newConfig = cloneDeep(config)
  if (!data) return newConfig
  const configFromProp = cloneDeep(_config)
  const configResult = defaultsDeep(configFromProp, props.config, newConfig)

  configResult.series[0].name = data.name
  configResult.series[0].data = data.data
  configResult.yAxis.data = data.axis
  configResult.yAxis.show = true

  if (data.data && data.data.length > 0) {
    // 移除暂无数据的文本
    // delete configResult.graphic;
    configResult.graphic[0].invisible = true
  } else {
    configResult.graphic[0].invisible = false
    configResult.yAxis.show = false
    configResult.xAxis.show = false
  }

  return configResult
}
const loading = () => {
  componentLoading.value = true
}
const setData = (data: { data: DataItem; config?: EChartsOption }) => {
  const result = componentPropEngine(data)
  chartConfig.value = result
  componentLoading.value = false
}
defineExpose({ setData, loading, show, hide, changeVisible })
</script>

<style lang="scss">
.compare-line-chart {
  height: 100%;
}
</style>
.
